import { CommonFolderIcon, EmojiIcon, LockedFolderIcon } from 'screens/Finder/components/FileIcon/FileIcon'

import Styles from './FolderIcon.module.scss'

interface Props {
  defaultFolder?: boolean
  header_emoji?: string | null | undefined
  className?: string
}

export const FolderIcon = ({ defaultFolder, header_emoji, className }: Props) => {
  const icon = () => {
    if (defaultFolder) {
      return <LockedFolderIcon className={className} />
    }
    if (header_emoji) {
      return <EmojiIcon emoji={header_emoji} className={className} />
    }
    return <CommonFolderIcon className={className} />
  }

  return <div className={Styles.iconContainer}>{icon()}</div>
}
